module.exports = __webpack_public_path__ + "img/exam-ko-erased.2e7f46c4.webp";